import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Carousel } from "../home/slider";
import SearchField from "../common/SearchField";
import FilterSidebar from "./FilterSidebar";
import {
  addFavourite,
  addGuestLastPlayed,
  getFavGames,
} from "../../features/slices/UserSlice";
import { openLoginModal } from "../../features/slices/ModalSlice";
import {
  fetchCategories,
  fetchProviders,
  getGames,
  setGameFilters,
} from "../../features/slices/GamesSlice";
import useFavouriteGame from "../common/useFavouriteGame";
import { buildPlayGameUrl } from "../../utils/playGameUrl";
import { getGameImage } from "../../utils/gameImage";

export default function AllGames() {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const game = useSelector((state) => state.game);
  const user = useSelector((state) => state.user);
  const { allGames, totalGames, gamesLoading, gameFilters } = game;
  const [ready, setReady] = useState(false);

  console.log(game, "game")
  // load filter options + seed the category passed from home (?category=<id>)
  useEffect(() => {
    if (!game.categories.length) dispatch(fetchCategories());
    if (!game.providers.length) dispatch(fetchProviders());
    const categoryId = searchParams.get("category");
    dispatch(
      setGameFilters({
        categories: categoryId ? [categoryId] : [],
        providers: [],
        search: "",
      })
    );
    setReady(true);
  }, []);

  // (re)fetch the first page whenever filters change
  useEffect(() => {
    if (ready) dispatch(getGames({ offset: 0, ...gameFilters }));
  }, [ready, gameFilters]);

  // infinite scroll: fetch the next page near the bottom
  useEffect(() => {
    const onScroll = () => {
      const nearBottom =
        window.innerHeight + window.scrollY >=
        document.documentElement.scrollHeight - 400;
      if (nearBottom && !gamesLoading && allGames.length < totalGames)
        dispatch(getGames({ offset: allGames.length, ...gameFilters }));
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [allGames.length, totalGames, gamesLoading, gameFilters]);

  const { requestToggle, favouriteUI } = useFavouriteGame();
  const favouriteIds = new Set(user.favGames.map((g) => String(g.id)));
  const isFavourite = (item) =>
    item.is_favorite || favouriteIds.has(String(item.id));

  // known favourites so stars show filled before the user toggles anything
  useEffect(() => {
    if (user.userLoggedIn) dispatch(getFavGames());
  }, [user.userLoggedIn]);

  // finish a favourite the user started while logged out
  useEffect(() => {
    if (!user.userLoggedIn) return;
    const pending = localStorage.getItem("toAddFav");
    if (pending) {
      const item = JSON.parse(pending);
      if (!isFavourite(item)) dispatch(addFavourite({ gameId: item.id, game: item }));
      localStorage.removeItem("toAddFav");
    }
  }, [user.userLoggedIn]);

  const openLoginWhenLoggedOut = (item) => {
    if (user.userLoggedIn) return;
    dispatch(addGuestLastPlayed(item));
    dispatch(openLoginModal());
  };

  return (
    <div>
      <Carousel />
      <SearchField />
      <div className="all-games-section" id="gamesDiv">
        <FilterSidebar />
        <div className="games-area">
          {allGames.length ? (
            <div className="games-grid">
              {allGames.map((item) => (
                <div
                  className="game-tile"
                  key={item.id}
                  onClick={() => openLoginWhenLoggedOut(item)}
                >
                  <a
                    href={
                      user.userLoggedIn ? buildPlayGameUrl(item) : undefined
                    }
                  >
                    <img
                      loading="lazy"
                      src={getGameImage(item)}
                      alt={item.name}
                    />
                    <i
                      className={`bi ${
                        isFavourite(item) ? "bi-star-fill" : "bi-star"
                      }`}
                      title={
                        isFavourite(item)
                          ? "Remove From Favourites"
                          : "Add To Favourites"
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        requestToggle(item, isFavourite(item));
                      }}
                    ></i>
                    <div className="game-tile-info">
                      <p>{item.name}</p>
                      <span>{item.provider_name}</span>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          ) : (
            !gamesLoading && (
              <div className="games-empty">
                <i className="bi bi-controller"></i>
                <p>No games match your filters.</p>
              </div>
            )
          )}
          {gamesLoading && (
            <div className="d-flex justify-content-center p-4">
              <img
                loading="lazy"
                src={require("../../assets/images/loading.gif")}
                width={120}
                height={120}
                alt="loading"
              />
            </div>
          )}
        </div>
      </div>
      {favouriteUI}
    </div>
  );
}
